import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { Box, Flex } from 'atoms';

export default function FilterTag({ children, onClose, ...props }) {
	return (
		<Flex
			alignItems="center"
			backgroundColor="#f0f5ff"
			color="#1890ff"
			padding="4px 10px"
			borderRadius="4px"
			border="1px solid #d6e4ff"
			boxShadow="0 1px 2px rgba(0, 0, 0, 0.05)"
			margin="0 2px"
			fontSize="12px"
			fontWeight="500"
			{...props}
		>
			<Box marginRight="6px">{children}</Box>
			<CloseOutlined
				onClick={onClose}
				style={{
					cursor: 'pointer',
					fontSize: '10px',
					color: '#1890ff',
				}}
			/>
		</Flex>
	);
}

FilterTag.propTypes = {
	children: PropTypes.node.isRequired,
	onClose: PropTypes.func.isRequired,
};
